import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import Information from "../../../pages/ServicosAcolhimento/Perfil/InformationPerfil";

export const Perfil = ({ data }) => {
  const handleRestricoes = (restricoes) => {
    if (restricoes.length > 1) {
      return restricoes
        .map((rest, index) => {
          if (
            index !== restricoes.length - 1 &&
            index !== restricoes.length - 2
          ) {
            return rest + ",";
          } else if (index === restricoes.length - 2) {
            return rest;
          } else {
            return "e " + rest;
          }
        })
        .join(" ");
    } else {
      return restricoes.join();
    }
  };

  return data ? (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#DDEBEA"
          title="Perfil do Serviço"
          mt="15px"
          py="12px"
          mtDivider="5px"
        >
          <Information
            title="Faz Restrição de Gênero?"
            information={data.restricaoGenero === "S" ? "Sim" : "Não"}
            mt="10px"
          />
          {data.restricaoGenero === "S" && (
            <Information
              mt="0px"
              title="Restrições:"
              information={handleRestricoes(JSON.parse(data.restricoes))}
            />
          )}

          <Information
            title="Faz Restrição de Faixa Etária?"
            information={data.restricaoIdade === "S" ? "Sim" : "Não"}
            mt="10px"
          />
          {data.restricaoIdade === "S" && (
            <>
              <Text
                fontWeight={600}
                fontSize="14px"
                lineHeight="19.6px"
                color="#000"
              >
                Idades aceitas pelo serviço:
              </Text>
              <Information
                mt="0px"
                title="Idade Mínima Aceita Pelo Serviço:"
                information={data.idadeMinima}
              />
              <Information
                mt="0px"
                title="Idade Máxima Aceita Pelo Serviço:"
                information={data.idadeMaxima}
              />
            </>
          )}
          <Information
            title="Faz restrição de criança/adolescente com deficiência?"
            information={data.restricaoDeficiencia === "S" ? "Sim" : "Não"}
            mt="10px"
          />
          <Information
            title="Faz Restrição de Criança/Adolescente que faz uso de Substâncias Psicoativas?"
            information={data.restricaoSubstancias === "S" ? "Sim" : "Não"}
            mt="10px"
          />
          <Information
            title="Faz restrição de criança/adolescente que Demanda Cuidados de Saúde?"
            information={data.restricaoCuidados === "S" ? "Sim" : "Não"}
            mt="10px"
          />
          <Information
            title="Capacidade de Atendimento:"
            information={data.capacidadeAcolhimento}
            mt="10px"
          />

          <Information
            title="Vagas Ocupadas:"
            information={data?.servicoAcolhimento?.vagasOcupadas || 0}
            mt="10px"
          />
          <Information
            title="Vagas Disponíveis:"
            information={
              data.capacidadeAcolhimento -
                data?.servicoAcolhimento?.vagasOcupadas || 0
            }
            mt="10px"
          />
          {data.servicoAcolhimento.tipoServicoAcolhimento.regime === "SAF" && (
            <>
              <Information
                title="Quantidade de Acolhedores Cadastrados:"
                information="0"
                mt="10px"
              />
              <Information
                title="Quantidade de Acolhedores em Atuação:"
                information="0"
                mt="10px"
              />
            </>
          )}
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#DDEBEA"
          title="Perfil do Serviço"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
